import type { AppRouter } from "@ai-admin/api/types";
import { QueryClient } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import superjson from "superjson";

export const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 10_000 } } });

const client = createTRPCClient<AppRouter>({ links: [httpBatchLink({ url: "/trpc", transformer: superjson })] });

/** Типизированный доступ к API: `useQuery(trpc.auth.me.queryOptions())`. */
export const trpc = createTRPCOptionsProxy<AppRouter>({ client, queryClient });

export function trpcErrorCode(error: unknown): string | null {
  const data = (error as { data?: { appCode?: string | null; code?: string } } | null)?.data;
  return data?.appCode ?? data?.code ?? null;
}

/** Подробности ошибки сервиса (`AppError.details`), например `{ reason: "linked" }`, чтобы различать отказы одного кода. */
export function trpcErrorDetails(error: unknown): Record<string, unknown> | null {
  const data = (error as { data?: { details?: Record<string, unknown> | null } } | null)?.data;
  return data?.details ?? null;
}
